var _g, _rect, _path, _path2, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 82,
    viewBox: "0 0 299 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_3555)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 298.207,
    height: 56.6216,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 23.2329,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 79 23.2329)",
    fill: "#0047AB",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.2329,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 83 23.2329)",
    fill: "#0047AB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.2329,
    width: 201.229,
    height: 184.264,
    transform: "rotate(-35.5519 83 23.2329)",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.15 47.6C141.186 47.6 143.54 49.954 143.54 52.88C143.54 55.806 141.186 58.16 138.15 58.16H135.84V63H132.32V47.6H138.15ZM138.15 54.86C139.228 54.86 140.02 54.002 140.02 52.88C140.02 51.758 139.228 50.9 138.15 50.9H135.84V54.86H138.15ZM148.817 59.612H154.317V63H145.297V47.6H148.817V59.612ZM166.087 63L165.317 60.58H159.597L158.827 63H154.977L160.213 47.6H164.701L169.937 63H166.087ZM160.653 57.28H164.261L162.457 51.626L160.653 57.28ZM180.494 47.6V50.988H176.534V63H173.014V50.988H169.054V47.6H180.494ZM182.035 47.6H185.555V63H182.035V47.6ZM196.781 47.6H200.301V63H197.661L191.721 54.64V63H188.201V47.6H190.841L196.781 55.96V47.6ZM208.769 63.308C205.381 63.308 202.829 61.328 202.829 58.028V47.6H206.349V57.72C206.349 58.886 206.899 59.876 208.769 59.876C210.639 59.876 211.189 58.886 211.189 57.72V47.6H214.709V58.028C214.709 61.328 212.157 63.308 208.769 63.308ZM232.648 47.6V63H229.128V54.046L225.146 60.58H224.75L220.768 54.046V63H217.248V47.6H220.768L224.948 54.442L229.128 47.6H232.648ZM251.135 47.6V50.988H247.175V63H243.655V50.988H239.695V47.6H251.135ZM252.675 47.6H256.195V63H252.675V47.6ZM262.361 59.612H268.521V63H258.841V47.6H268.411V50.988H262.361V53.54H267.861V56.884H262.361V59.612ZM278.604 63L275.7 57.94H274.028V63H270.508V47.6H276.668C279.594 47.6 281.948 49.954 281.948 52.88C281.948 54.772 280.803 56.488 279.11 57.346L282.388 63H278.604ZM274.028 50.9V54.86H276.668C277.636 54.86 278.428 54.002 278.428 52.88C278.428 51.758 277.636 50.9 276.668 50.9H274.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_3555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.678 52.447C68.0782 52.8742 64.2297 50.1661 63.4926 50.1602C62.7555 50.1543 58.8637 52.8001 58.2709 52.3633C57.6781 51.9265 59.0717 47.4399 58.8497 46.739C58.6276 46.0382 54.9014 43.165 55.1348 42.4678C55.3682 41.7706 60.0781 41.7059 60.6778 41.2787C61.2776 40.8515 62.8666 36.4299 63.6037 36.4358C64.3407 36.4417 65.8579 40.8883 66.4507 41.3251C67.0435 41.7619 71.7517 41.9025 71.9738 42.6033C72.1959 43.3041 68.4238 46.117 68.1903 46.8142C67.9569 47.5114 69.2778 52.0198 68.678 52.447Z",
    fill: "url(#paint0_linear_26_3555)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 25.25,
    width: 297.707,
    height: 56.1216,
    rx: 9.75,
    stroke: "url(#paint1_linear_26_3555)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M51.2171 54.122L44.2137 50.7317L36.3102 60.1571L34.9832 58.2733L36.635 45.6029L30.0926 25.9106L15.0991 31.2188L19.0926 41.2722L31.9269 72.1686L34.7574 79.1689L35.0852 77.1365L38.2126 65.2117L42.5835 60.3582L50.388 59.7581L37.959 51.1555L51.2171 54.122Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1439 17.0453C43.7805 17.0453 47.5392 13.4181 47.5392 8.94377C47.5392 4.46944 43.7805 0.842285 39.1439 0.842285C34.5073 0.842285 30.7485 4.46944 30.7485 8.94377C30.7485 13.4181 34.5073 17.0453 39.1439 17.0453Z",
    fill: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3015 65.8488L56.1944 68.4132C54.7095 65.5889 51.5605 63.7175 47.9939 64.0021C43.8209 64.3361 40.4925 67.6924 40.3193 71.7292C40.2543 73.2357 40.6131 74.6586 41.2999 75.8898L40.9534 76.063L38.2251 77.4303L34.7605 79.1687C32.9726 75.1319 31.4599 71.0796 30.1824 67.0799C29.9751 66.4396 29.774 65.7931 29.5823 65.1528V65.1466C29.44 64.6764 29.2977 64.1938 29.1894 63.8195C29.0811 63.4483 29.0069 63.1916 29.0069 63.1916C26.7147 55.1953 25.3134 47.5269 24.472 40.7988L24.4782 40.9288C23.3584 33.5449 23.3027 25.5053 23.3027 25.5053C23.2656 24.169 23.2563 22.9595 23.2563 21.8923C23.2563 21.2458 23.2564 20.6488 23.2687 20.1105C23.3028 17.9699 23.3801 16.7047 23.3894 16.5253V16.5037L27.8624 17.11L30.1205 17.4873C30.105 17.6853 30.0958 17.8864 30.0958 18.0875C30.0958 22.5635 33.8542 26.1889 38.488 26.1889C42.3547 26.1889 45.6058 23.671 46.5802 20.2404L48.993 20.6426L52.6741 21.2891V21.3045C52.6648 21.4314 52.5659 23.2379 52.5782 26.1425C52.5782 26.1425 52.7917 34.3337 53.1381 37.4951C53.5743 41.9774 54.3105 46.9422 55.5571 51.7957C55.5633 51.8112 55.5664 51.8235 55.5695 51.839C56.0397 53.7476 56.1046 53.8064 56.1077 53.8064C57.3575 58.1278 59.0402 62.2852 61.3046 65.8457L61.3015 65.8488Z",
    fill: "#0047AB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2274,
    cy: 44.8176,
    r: 13.9054,
    stroke: "url(#paint2_linear_26_3555)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_3555",
    x1: 55.1243,
    y1: 44.4643,
    x2: 71.9833,
    y2: 44.4643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00357F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_3555",
    x1: 0.00000223544,
    y1: 53.6217,
    x2: 149.104,
    y2: 81.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_3555",
    x1: 63.2274,
    y1: 30.6622,
    x2: 63.2274,
    y2: 58.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_3555"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 298.207,
    height: 56.6216,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_3555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(54 35.6217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/Platinum.b6785bfc987aebc20e4c1ae5c0f2e41f.svg";
export { ForwardRef as ReactComponent };